import { useState } from "react";
import { Gift, CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function GiftCodeField({ form, setForm, tierPrice }) {
  const [code, setCode] = useState(form.gift_code || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const applied = form.gift;

  const apply = async () => {
    const c = code.trim().toUpperCase();
    if (!c) return;
    setBusy(true); setError("");
    try {
      const r = await api.get(`/gifts/check/${encodeURIComponent(c)}`);
      if (Number(r.data.amount_usd) < Number(tierPrice)) { setError(`This gift covers the ${r.data.service_name} — pick that session (or a shorter one).`); return; }
      setForm({ ...form, gift_code: c, gift: r.data });
    } catch (e) { setError(e?.response?.data?.detail || "That code didn't work"); }
    finally { setBusy(false); }
  };
  const clear = () => { setCode(""); setForm({ ...form, gift_code: "", gift: null }); };

  if (applied) {
    return (
      <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-4 flex items-start gap-3" data-testid="gift-applied">
        <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
        <div className="text-sm">
          <div className="font-semibold text-emerald-100">Gift code {applied ? form.gift_code : ""} applied — nothing to pay.</div>
          <div className="text-emerald-100/80 mt-0.5">Covers the {applied.service_name} for {applied.recipient_name}. Your session is confirmed as soon as you book.</div>
          <button type="button" onClick={clear} className="dg-link text-xs mt-2" data-testid="gift-remove">Use a different code</button>
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/40 p-4" data-testid="gift-code-field">
      <div className="dg-eyebrow mb-2 flex items-center gap-2"><Gift className="w-3 h-3 text-[#FFD600]" /> Have a gift code?</div>
      <div className="flex flex-wrap gap-2">
        <input className="dg-input flex-1 min-w-[180px] font-mono uppercase" value={code} onChange={(e) => setCode(e.target.value)} placeholder="GIFT-XXXX-XXXX" data-testid="gift-code-input" />
        <button type="button" onClick={apply} disabled={busy || !code.trim()} className="dg-btn-ghost rounded-full px-4 py-2 text-sm disabled:opacity-40" data-testid="gift-code-apply">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Apply"}</button>
      </div>
      {error && <div className="text-xs text-rose-300 mt-2" data-testid="gift-code-error">{error}</div>}
    </div>
  );
}
